import Card from './Card';


Card.install = function(Vue) {
  Vue.component(Card.name, Card);
};

export default Card;
